// Products whose description highlights specific marketing terms in the product dropdown
export const ADVANCE_HIGHLIGHT_PARTNAMES = [
  "202002300027",
  "202002300043",
  "202002300041",
  "202002300042",
  "202000200007",
  "202002300037",
];

export const HIGHLIGHT_WORDS = ["FIBER", "ADVANCE", "COMPACT"];

// Products that require explicit confirmation before being added to the order
export const ADVANCE_CONFIRM_PARTNAMES = [
  "202002300043",
  "202002300041",
  "202002300042",
  "202000200007",
];

export const ADVANCE_CONFIRM_TITLE = "שים לב";
export const ADVANCE_CONFIRM_MESSAGE = "שים לב, מדובר במוצר מסוג אנשור פלוס אדוונס";
